import React from 'react';
import PaperBase from '../../../Paper/PaperBase';
import { Skeleton, Tooltip, Typography } from '@mui/material';
import {
  ContentTooltiptLearningContinuumInfo,
  useStyles
} from '../../../Dashboard/Assessment/Classes/MarkingClasses/ContentTooltip/ContentTooltip';
import TextStatusUnitOfLearning from '../../../text/TextStatus';
import TextEllipsis from '../../../text/TextEllipsis';

const LearningContinuumCards = ({
  lcs = [],
  size,
  currentCurriculum,
  classUlInfo,
  direction = 'row',
  isLoading,
  top = '0px'
}) => {
  const classes = useStyles();
  const style = {
    width: direction === 'row' ? size * 6 : size,
    height: size,
    fontSize: 10
  };
  const styleVersion = {
    width: direction === 'row' ? size / 2 : size,
    height: direction === 'row' ? size : size / 2,
    fontSize: 10
  };
  const styleClassUlInfo = {
    width: direction === 'row' ? size * 3 : size,
    height: size,
    fontSize: 10
  };
  const lcElement = currentCurriculum?.lcElements?.children?.sort((a, b) => b.position - a.position)[0];
  const leftpx = classUlInfo ? size * 3 : size / 2;
 
  const RenderVersion = (
    <>
      {classUlInfo ? (
        <div
          className={[
            'flex flex-nowrap w-full gap-1 z-20 sticky',
            direction === 'row' ? 'flex-col left-0 ' : 'bottom-0'
          ].join(' ')}
        >
          <PaperBase
            className={['font-bold flex flex-col sticky bg-muted-foreground text-muted text-sm ' , `top-${top}`].join(
              ' '
            )}
            style={styleClassUlInfo}
          >
            <Typography variant='inherit' children='Version / Class' className=' text-xs' />
            <Typography
              variant='inherit'
              children='Unit of Learning'
              size='small'
              className='font-bold text-sm'
            />
          </PaperBase>
          {lcs?.map((lc, index) => {
            const clss = lc.classes[0];
            const ul = lc.developmentalRubrics[0];
            return isLoading ? (
              <Skeleton
                variant='rounded'
                key={`lc-elements-version-lc-${lc._id}-ul-${lc.ulId || 'main'}-class-${
                  lc.classId || 'main'
                }-index-${index}`}
                className='p-2'
                style={styleClassUlInfo}
              />
            ) : (
              <PaperBase
                key={`lc-elements-version-lc-${lc._id}-ul-${lc.ulId || 'main'}-class-${
                  lc.classId || 'main'
                }-index-${index}`}
                className={['font-bold flex flex-col bg-muted-foreground text-muted text-sm '].join(' ')}
                style={styleClassUlInfo}
              >
                <Typography
                  children={`V${lc.version || 1} / ${clss?.code || 'MAIN'}`}
                  size='small'
                  className='font-bold text-xs'
                />
                {ul ? (
                  <TextEllipsis variant='inherit' className='font-bold text-xs'>
                    <TextStatusUnitOfLearning startDate={ul?.startDate} endDate={ul?.endDate} />
                    <span className='font-bold text-xs pl-1'>{ul?.name || ''}</span>
                  </TextEllipsis>
                ) : (
                  <span className='font-bold text-sm'>-</span>
                )}
              </PaperBase>
            );
          })}
        </div>
      ) : (
        <div
          className={[
            'flex flex-nowrap w-full gap-1 z-20 sticky',
            direction === 'row' ? 'flex-col left-0 ' : 'bottom-0'
          ].join(' ')}
        >
          <PaperBase
            className={['font-bold sticky bg-muted-foreground text-muted ', `top-${top}`].join(' ')}
            children='V'
            style={styleVersion}
          />
          {lcs?.map((lc, index) => {
            return (
              <PaperBase
                key={`lc-elements-version-lc-${lc._id}-ul-${lc.ulId || 'main'}-class-${
                  lc.classId || 'main'
                }-index-${index}`}
                style={styleVersion}
                className={[' bg-muted-foreground text-muted  w-full text-ellipsis'].join(' ')}
                children={
                  <Typography
                    children={`V${lc.version || 1}${lc.ulId === '' ? ' (main)' : ''}`}
                    size='small'
                    className='font-bold text-sm'
                  />
                }
              />
            );
          })}
        </div>
      )}
    </>
  );
  return (
    <>
      {direction === 'row' && RenderVersion}
      <div
        className={['flex flex-nowrap w-full gap-1 z-20 sticky', direction === 'row' ? 'flex-col ' : ''].join(
          ' '
        )}
        style={
          direction === 'row'
            ? { left: `calc(${leftpx}px + 1.25rem)` }
            : { bottom: `calc(${leftpx}px + 1.25rem)` }
        }
      >
        <PaperBase
          className={['font-bold sticky bg-muted-foreground text-muted  text-sm', `top-${top}`].join(' ')}
          children={lcElement?.name || 'Learning continuum'}
          style={style}
        />
        {lcs?.map((lc, index) => {
          return isLoading ? (
            <Skeleton
              variant='rounded'
              key={`lc-elements-version-lc-${lc._id}-ul-${lc.ulId || 'main'}-class-${
                lc.classId || 'main'
              }-index-${index}`}
              className='p-2'
              style={style}
            />
          ) : (
            <PaperBase
              key={`lc-elements-version-lc-${lc._id}-ul-${lc.ulId || 'main'}-class-${
                lc.classId || 'main'
              }-index-${index}`}
              style={style}
              className={[' bg-muted-foreground text-muted flex flex-col w-full text-ellipsis'].join(' ')}
              children={
                <Tooltip
                  arrow
                  placement='top'
                  id={`guttman-chart-table-lc-lc-${lc._id}`}
                  title={
                    <ContentTooltiptLearningContinuumInfo lc={lc} currentCurriculum={currentCurriculum} />
                  }
                  classes={{ tooltip: classes.customWidthGuttmanChart }}
                >
                  <Typography
                    children={lc.lcElements[lcElement?._id] || 'None'}
                    style={{
                      height: size,
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical'
                    }}
                    className=' text-sm flex items-center justify-start'
                  />
                  {/* {lc._id} */}
                </Tooltip>
              }
            />
          );
        })}
      </div>
      {direction === 'column' && RenderVersion}
    </>
  );
};

export default LearningContinuumCards;
